import {BOOKLIST_CREATED, EDIT_BOOK_LIST_META_DATA} from "../types";

export default function bookListCUD(state = {}, action = {}) {
    switch (action.type) {
        case BOOKLIST_CREATED:
            return action.data;
        case EDIT_BOOK_LIST_META_DATA:
            return action.data;
        default:
            return state
    }
}